import React, { Component, Fragment } from 'react';
import root from 'window-or-global';
import PrivacyPolicy from 'blocks/PrivacyPolicy';
import Navigation from 'blocks/Navigation';
import NavigationAwarePageContent from 'blocks/NavigationAwarePageContent';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import InjectMetaTags from 'blocks/InjectMetaTags';
import CoreStore from 'stores/Core.store';

@inject('coreStore')
@observer
export default class PrivacyPolicyPage extends Component {
  static propTypes = {
    coreStore: PropTypes.instanceOf(CoreStore).isRequired,
  };

  componentDidMount() {
    root.scrollTo(0, 0);
  }

  render() {
    const {
      coreStore: { content: { privacyPolicySEO } }
    } = this.props;

    return (
      <Fragment>
        <InjectMetaTags {...privacyPolicySEO} />
        <Navigation />
        <NavigationAwarePageContent>
          <PrivacyPolicy />
        </NavigationAwarePageContent>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/PrivacyPolicy/index.jsx